import { useMemo } from 'react';

import { DTOProfileCard as UserProfile } from 'src/apis/dto/DTOProfileCard';
import { useDMFriendsListQuery } from 'src/hooks/useDirectMessageQuery';
import { useMyProfile } from 'src/hooks/useMyProfile';
import { GENDER } from 'src/types/register';

const makeGenderImages = (gender: string) =>
  [...Array(18)].map((_, i) => `/images/dummyFaces/imgRandom${gender}${i + 1}.png`);

function getRandomProfileImage(profile?: UserProfile) {
  const { gender } = profile ?? {};

  const TargetGenderMap = {
    [GENDER.MALE]: GENDER.FEMALE,
    [GENDER.FEMALE]: GENDER.MALE,
  } as const;

  const genderImages =
    gender === GENDER.MALE || gender === GENDER.FEMALE
      ? makeGenderImages(TargetGenderMap[gender])
      : [makeGenderImages(GENDER.MALE), makeGenderImages(GENDER.FEMALE)].flat();

  const randomIndex = Math.floor(Math.random() * genderImages.length);
  const randomImage = genderImages.splice(randomIndex, 1).pop();
  return randomImage;
}

const useFriendsPhotos = (length = 3) => {
  const profile = useMyProfile();

  const { data: { follows = [] } = {} } = useDMFriendsListQuery();

  return useMemo(
    () =>
      [
        ...follows.map(
          ({ profileMediaInfo }) =>
            profileMediaInfo?.thumbnailImageUrl ?? '/images/profile/imgProfile.png'
        ),
        ...Array.from({ length }).map(() => getRandomProfileImage(profile)),
      ]
        .filter((v): v is string => Boolean(v))
        .slice(0, length),
    [follows, profile, length]
  );
};

export default useFriendsPhotos;
